import { useEffect, useState } from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import editIconWhite from "../../assets/images/edit-icon-white.svg";
import plusIconWhite from "../../assets/images/plus-icon-white.svg";
import { ModalLimitesCuenta } from "./ModalLimitesCuenta";
import downloadIconWhite from "../../assets/images/download-icon-white.svg";
import deleteIcon from "../../assets/images/delete-icon-new.svg";
import { ModalEliminarVehiculos } from "./ModalEliminarVehiculos";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../ui/LogoPetroprix";
import DeleteIcon from "../../assets/images/componets/DeleteIcon";

export const FlotasActions = ({
  controlKM,
  onChange,
  vehiculos,
  vehicleSelected,
  setVehicleSelected,
}) => {
  // const [notifications, setNotifications] = useState(true);
  const { flotaActiva } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const [deleteVehicles, setDeleteVehicles] = useState(1);

  const [modalDeleteVehicles, setModalDeleteVehicles] = useState({
    show: false,
    vehicles: [],
  });

  const [modalLimites, setModalLimites] = useState({
    show: false,
  });

  const changeSelectVehicles = () => {
    setDeleteVehicles(!deleteVehicles);
    eliminarVehiculos();
  };

  const eliminarVehiculos = async () => {
    let selectedVehicles = [];
    const vehicles = document.querySelectorAll("div.vehiculo");
    vehicles.forEach((vehiculo) => {
      const checkbox = vehiculo.querySelector("input[type=checkbox]");
      if (checkbox.checked) {
        const id = checkbox.value;
        const v = vehiculos.find((item) => item.idTar == id);
        selectedVehicles.push({
          idTar: v.idTar,
          matricula: v.matricula,
        });
      }
    });
    if (selectedVehicles.length > 0) {
      setModalDeleteVehicles({
        show: true,
        vehicles: selectedVehicles,
      });
    } else {
      toast(t("flotas.table.seleccione-uno"), {
        icon: <LogoPetroprix />,
      });
    }
  };

  const updateRow = (id, tipo, info = null) => {
    onChange();
  };

  return (
    <>
      <Row className="mt-1 flotas-buttons">
        {flotaActiva.permisos && flotaActiva.activo === "1" ? (
          <>
            <Col xs={12}>
              <Stack direction="horizontal" gap={2}>
                <Button
                  variant="primary"
                  className="flotas-btn-add ms-auto"
                  onClick={() => {
                    setModalLimites({ ...modalLimites, show: true });
                  }}
                >
                  <img src={editIconWhite} alt="" width={14} />{" "}
                  {t("flotas.actions.limites-diarios")}
                </Button>

                {flotaActiva.tipo_pago === "prepago" && (
                  <Button
                    variant="primary"
                    className="flotas-btn-add"
                    href="agregar-saldo"
                  >
                    <img src={plusIconWhite} alt="" width={14} />{" "}
                    {t("flotas.actions.add-saldo")}
                  </Button>
                )}

                <Button
                  href="nuevo-vehiculo"
                  variant="primary"
                  className="flotas-btn-add"
                >
                  <img src={plusIconWhite} alt="" width={14} />{" "}
                  {t("flotas.actions.add-vehiculo")}
                </Button>

                <Button
                  href="importar-vehiculos"
                  variant="primary"
                  className="flotas-btn-add"
                >
                  <span className="p-1">
                    <img src={downloadIconWhite} alt="" width={14} />
                  </span>
                  {t("flotas.actions.importar-vehiculos")}
                </Button>

                <Button
                  variant="primary"
                  id="flotas-eliminar"
                  className="flotas-btn-add"
                  onClick={() => changeSelectVehicles()}
                  disabled={!vehicleSelected}
                >
                  <span className="p-1">
                    <DeleteIcon
                      width={14}
                      strokeColor={!vehicleSelected ? "#2b363b" : "#ffffff"}
                      strokeOpacity={!vehicleSelected ? "0.25" : "1"}
                    />
                  </span>
                  {t("flotas.table.eliminar")}
                </Button>
              </Stack>
            </Col>
          </>
        ) : (
          <></>
        )}
      </Row>

      <ModalLimitesCuenta
        show={modalLimites.show}
        onHide={() => {
          setModalLimites({ ...modalLimites, show: false });
        }}
      />

      <ModalEliminarVehiculos
        show={modalDeleteVehicles.show}
        onHide={(deleted = false) => {
          if (deleted) {
            modalDeleteVehicles.vehicles.forEach((vehiculo) => {
              updateRow(vehiculo.idTar, "delete");
            });
            setVehicleSelected(false);
          }
          setModalDeleteVehicles({ ...modalDeleteVehicles, show: false });
        }}
        vehicles={modalDeleteVehicles.vehicles}
      />
    </>
  );
};
